import * as React from 'react';
import styled from 'styled-components';
import { colors } from 'spw-theme';
import { useSelector } from 'react-redux';
import { selectCurrentUserIsViewOnly } from 'spw-redux/modules/projects/selectors';

const ImageWrapper = styled.div<{ $containerHeight?: number }>`
  && {
    height: ${({ $containerHeight }) => $containerHeight || 40}px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    border-radius: 4px;

    &:hover {
      background-color: ${colors.backgroundGrey};
    }

    &.selected {
      background-color: ${colors.backgroundGrey};
    }

    &.small {
      width: 32px;
      display: flex;
      height: 100%;
    }
  }

  &&.disabled {
    cursor: default;

    &:hover {
      background-color: transparent;
    }
  }
`;

type Props = {
  iconPath: string;
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  height?: number;
  width?: number;
  containerHeight?: number;
  isSelected?: boolean;
  isSmallIcon?: boolean;
};

const CardIcon: React.FC<Props> = ({
  iconPath,
  onClick,
  height,
  isSelected,
  isSmallIcon,
  width,
  containerHeight,
}) => {
  const currentUserIsViewOnly = useSelector(selectCurrentUserIsViewOnly);

  return (
    <ImageWrapper
      $containerHeight={containerHeight}
      onClick={!currentUserIsViewOnly ? onClick : null}
      className={[
        isSelected ? 'selected' : '',
        isSmallIcon ? 'small' : '',
        currentUserIsViewOnly ? 'disabled' : '',
      ]
        .join(' ')
        .trim()}
    >
      <img alt="icon" src={`${iconPath}.svg`} height={height} width={width} />
    </ImageWrapper>
  );
};

export default CardIcon;
